import { theme } from '~/tailwind.config.js'

export default {
  data: () => ({
    mdBreakpoint: theme.extend.screens.md,
    isMdBreakpointOrAbove: false
  }),

  computed: {
    mediaQueryList () {
      return window.matchMedia(`(min-width: ${this.mdBreakpoint})`)
    }
  },

  mounted () {
    this.mediaQueryListMatches()
    this.mediaQueryList.addListener(this.mediaQueryListMatches)
  },

  destroyed () {
    this.mediaQueryList.removeListener(this.mediaQueryListMatches)
  },

  methods: {
    mediaQueryListMatches () {
      this.isMdBreakpointOrAbove = this.mediaQueryList.matches
    }
  }
}